import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { GameProvider } from "./context/game";
import { ThemeProvider } from "./context/theme";
import { BoardSkinProvider } from "./context/boardSkin";
import { AwaitGamePage } from "./pages/gamePage/awaitGamePage";
import { gamePageLoader } from "./loaders/loaders";
import { PrivateRoomsPage } from "./pages/onlineMultiplayer";
import { AuthProvider } from "./context/auth";
import { LoaderWrapper } from "./pages/gamePage/LoaderPage";
import "react-toastify/dist/ReactToastify.css";
import "./styles/customToast.css";

const router = createBrowserRouter([
  {
    path: "/online-multiplayer",
    element: (
      <LoaderWrapper>
        <GameProvider>
          <PrivateRoomsPage />
        </GameProvider>
      </LoaderWrapper>
    ),
  },
  {
    path: "/",
    element: <AwaitGamePage></AwaitGamePage>,
    loader: gamePageLoader,
  },
]);

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <BoardSkinProvider>
          <RouterProvider router={router} />
          <ToastContainer
            position="top-right"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />
        </BoardSkinProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
